var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26562 0.484375L6.51562 2.73438C6.82031 3.01562 6.82031 3.50781 6.51562 3.78906C6.23438 4.09375 5.74219 4.09375 5.46094 3.78906L4.5 2.82812V10C4.5 10.4219 4.14844 10.75 3.75 10.75C3.32812 10.75 3 10.4219 3 10V2.82812L2.01562 3.78906C1.73438 4.09375 1.24219 4.09375 0.960938 3.78906C0.65625 3.50781 0.65625 3.01562 0.960938 2.73438L3.21094 0.484375C3.49219 0.179688 3.98438 0.179688 4.26562 0.484375ZM11.0156 8.28906L8.76562 10.5391C8.48438 10.8438 7.99219 10.8438 7.71094 10.5391L5.46094 8.28906C5.15625 8.00781 5.15625 7.51562 5.46094 7.23438C5.74219 6.92969 6.23438 6.92969 6.51562 7.23438L7.5 8.19531V1C7.5 0.601562 7.82812 0.25 8.25 0.25C8.64844 0.25 9 0.601562 9 1V8.19531L9.96094 7.23438C10.2422 6.92969 10.7344 6.92969 11.0156 7.23438C11.3203 7.51562 11.3203 8.00781 11.0156 8.28906Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.b9a5dfd5bd9b6d77e440d6d6c0851a5a.svg";
export { ForwardRef as ReactComponent };